import { Injectable } from '@angular/core';
import { NetworkService } from '../infrastructure/network.service';
import { ConfigService } from '../infrastructure/config.service';
import { BehaviorSubject } from 'rxjs';
import { saveAs } from 'file-saver';
// View Model
import { AccountVM } from '../../models/AccountMasterVM';
import { SeedReservationGrowerOrderData } from '../../models/SeedReservationGrowerOrderData';

@Injectable()
export class SeedReservationReconciliationService {
  public isBackDropVisible = new BehaviorSubject<boolean>(false);
  public seedReservationId = new BehaviorSubject<[number, boolean]>([0, false]);
  public SelectedAccountObj: BehaviorSubject<AccountVM>;
  public SelectedGrowerObj: BehaviorSubject<SeedReservationGrowerOrderData>;
  public isAccountSelectedOnLP = false;
  public isGrowerSelectedOnLP = false;
  public SelectedGwrOrderId: BehaviorSubject<string>;

  constructor(public configService: ConfigService,
    public networkService: NetworkService) {
    this.seedReservationId = new BehaviorSubject<[number, boolean]>([0, false]);
    this.SelectedAccountObj = new BehaviorSubject<AccountVM>(null);
    this.SelectedGrowerObj = new BehaviorSubject<SeedReservationGrowerOrderData>(null);
    this.SelectedGwrOrderId = new BehaviorSubject<string>('0')
  }

  public AccountChange(obj: AccountVM) {
    this.SelectedAccountObj.next(obj);
  }

  public GrowerChange(obj: any) {
    this.SelectedGrowerObj.next(obj);
  }

  public SetAccountState(selected: boolean) {
    this.isAccountSelectedOnLP = selected;
  }

  public SetGrowerState(selected: boolean) {
    this.isGrowerSelectedOnLP = selected;
  }

  public setseedReservationId(value: number, isUpdate: boolean) {
    this.seedReservationId.next([value, isUpdate]);

  }

  public getConfirmationData(seedReservationId: number) {
    return this.networkService.getRequest(this.configService.getSeedReservationReconciliationConfirmationDataUrl() + '?seedReservationId=' + seedReservationId);
  }

  public getReconciliationProductAvailability(productFilters) {
    return this.networkService.postRequest(this.configService.getReconciliationProductAvailability(), productFilters);
  }
  public getProductIntialSetup(account, gmk, isParentGmk) {
    return this.networkService.getRequest(this.configService.getProductIntialSetup() + '?account=' + account + '&gmk=' + gmk + '&isParentGmk=' + isParentGmk);
  }

  // Get Grower order items
  public getSeedResGrowerOrderItems(growerOrderId, accountNo, cropYear) {
    return this.networkService.getRequest(this.configService.getSeedResGrowerOrderItemsUrl() + '?growerOrderId=' + growerOrderId + '&accountNo=' + accountNo + '&cropYear=' + cropYear);
  }

  // Get Grower List
  public getSeedResGrowerList(cropYear, accountId, growerOrderId, gmk) {
    return this.networkService.getRequest(this.configService.getSeedResGrowerListUrl() + '?cropYear=' + cropYear + '&accountId=' + accountId + '&growerOrderId=' + growerOrderId + '&gmk=' + gmk);
  }

  // Get Account details for Account dropdown
  public getSeedResAccounts() {
    return this.networkService.getRequest(this.configService.getSeedResAccountListUrl());
  }


  // Get Seller List
  public getSeedResSellerList(accountNo) {
    return this.networkService.getRequest(this.configService.getSellerListUrl() + '?accountNo=' + accountNo);
  }

  // Add or update grower order
  public growerOrderAddUpdate(data: any) {
    return this.networkService.postRequest(this.configService.seedResGrowerOrderAddUpdateUrl(), data);
  }

  public getHybridVarietyPackageSizeList(productFilters) {
    return this.networkService.postRequest(this.configService.getHybridVarietyPackageSizeListUrl(), productFilters);
  }
  public getProductAvailabilityHybridVariety(productFilters) {
    return this.networkService.postRequest(this.configService.getReconciliationProductAvailabilityHybridVariety(), productFilters);
  }

  public getReconciliationHybridVarietyProductList(productFilters) {
    return this.networkService.postRequest(this.configService.getReconciliationHybridVarietyProductList(), productFilters);
  }

}
